var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0c.775 0 1.51.176 2.164.492a5.784 5.784 0 00-1.06 1.186 3.5 3.5 0 10.136 6.596 5.7 5.7 0 001.106 1.142A5 5 0 115 0zm4.584 3c.268.613.416 1.29.416 2a4.98 4.98 0 01-.502 2.185 2.62 2.62 0 01-.998-2.06A2.62 2.62 0 019.584 3z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    cx: 11,
    cy: 5,
    r: 4.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualEvent);
export default __webpack_public_path__ + "static/media/virtual-event.384c3d09c8130a7982c364958d427082.svg";
export { ForwardRef as ReactComponent };